export default function CfInput() {
  return <div className="cf-info"></div>;
}
